import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template"];

  add(event) {
    if (event) event.preventDefault();

    // Clone the template content
    const clone = this.templateTarget.content.cloneNode(true);

    // Append the new element to the container
    this.containerTarget.appendChild(clone);
  }

  remove(event) {
    if (event) event.preventDefault();

    // Find the closest wrapper element (the row) and remove it
    const row = event.currentTarget.closest("[data-dynamic-list-row]");
    if (row) {
      row.remove();
    }
  }
}
